import * as core from '../../../../../../../core'

import { query } from './delete-monitoring-activity.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.delete-activity',
    description: 'Delete Monitoring Activity',
    name: 'Delete Monitoring Activity',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
